import { PRODUCT_LINE_CODE } from '../../../../../shared/constants/product-lines-codes';
import { readymix } from './readymix';

export const fr = {
  [PRODUCT_LINE_CODE.READY_MIX]: readymix,
};
